export const AUTH_CONSTANTS = {
  AUTH_APP: 'AUTH_APP',
  EMAIL: 'EMAIL',
  NO_2FA: 'NO_2FA',
  LOCAL: 'LOCAL',
  SAML: 'SAML',
};
